import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import DashboardLayout from "../../../layouts/dashboardLayout";
import { titlePage } from "../../../helpers/titleHead";

import ListTargetMediaModule from "../../../modules/Admin/TargetMedia/ListTargetMediaModule";

import { getTargetMediaAction } from "../../../../redux/action/serviceAction";

const ListTargetMediaPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    titlePage({
      title: "IRIS - Manajemen Target Media",
    });
    history.push("/admin/pm/list-target-media");

    dispatch(getTargetMediaAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardLayout title="Manajemen Target Media" menu="target-media">
      <ListTargetMediaModule />
    </DashboardLayout>
  );
};

export default ListTargetMediaPage;
